import React from 'react';
import { FORMS } from '../../schemas/stepMap';
import FormBuilder from '../../components/formBuilder';
import { useProperty } from '../../hooks/useProperty';
import { LeftColumn } from '../../components';
import { PageLoader } from '../../components';
import { Error } from '../../components';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useSteps } from '../../hooks/useSteps';
import BackForwardButtons from '../../components/buttons/BackForwardButtons';
import PropertyPageHeader from '../../components/PropertyPageHeader';

export default function CashFlow() {
  const { loading, error, propertyData, scenarios } = useProperty();
  const { pathname } = useLocation();
  const sharing = pathname.includes('sharing');

  const { prev, next } = useSteps();

  if (loading) {
    return (
      <LeftColumn fullWidth>
        <PageLoader />
      </LeftColumn>
    );
  }

  if (error && error.length) {
    return <Error error={error} />;
  }

  const scenarioData = scenarios.find((scenario) => !scenario.isDefault);
  const formSchema = FORMS.cashFlow.schema;

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - Income and Expenses</title>
      </Helmet>

      <section className="pt-6">
        {!sharing && (
          <PropertyPageHeader
            title={FORMS.cashFlow.name}
            description={FORMS.cashFlow.description}
          />
        )}

        <div className="pb-6">
          <FormBuilder
            formSchema={formSchema.calculations.schema}
            formType={FORMS.cashFlow.formType}
            beforeData={propertyData}
            afterData={scenarioData}
          />
        </div>
        <BackForwardButtons prev={prev} next={next} />
      </section>
    </>
  );
}
